import React from 'react'
import { Alert, Box, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'

// Leyenda de lo que hace falta para guardar una planilla nueva; cada campo se tilda cuando está completo
export default function CamposObligatorios({ campos }) {
    return (
        <Alert severity="info" sx={{ py: 0.25, alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    Obligatorios para guardar:
                </Typography>
                {campos.map(({ label, ok }) => (
                    <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {ok ? (
                            <CheckCircleIcon sx={{ fontSize: 16 }} color="success" />
                        ) : (
                            <RadioButtonUncheckedIcon sx={{ fontSize: 16 }} color="disabled" />
                        )}
                        <Typography variant="body2">{label}</Typography>
                    </Box>
                ))}
            </Box>
        </Alert>
    )
}
